import { Base64 } from 'js-base64';
import Icookie from 'cookiejs';
import CryptoJS from 'crypto-js';

export const isMobile = (() => {
  let UA = navigator.userAgent;
  let Sys = {
    ios: !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    android: UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1
  };
  return Sys.ios || Sys.android;
})();

export const types = (val: any) => {
  return typeof val;
};

export const isObject = (val: any) => {
  return types(val) === 'object';
};

export const isBoolean = (val: any) => {
  return types(val) === 'boolean';
};
export const isString = (val: any) => {
  return types(val) === 'string';
};
export const isFunction = (val: any) => {
  return types(val) === 'function';
};
export const isNumber = (val: any) => {
  return types(val) === 'number';
};

export const isObjectString = (val: any) => {
  return isString(val) && /^(\{.*\}|\[.*\])$/.test(val);
};

export const toNumber = (num: any) => {
  return parseFloat(num);
};

export const isArray = (val: any): any => {
  return (types(val) as any) === 'array';
};

export const isRealNum = (val: any) => {
  if (val === '' || val == null) {
    return false;
  }
  return !isNaN(val);
};

export const formatNumber = (val: any) => {
  let number = parseFloat(val);
  return number.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

export const dateFormat = (dateNumber: any, format = 'yyyy-MM-dd HH:mm:ss') => {
  if (dateNumber.toString().includes('-')) {
    dateNumber = dateNumber.replace(/-/g, '/');
    dateNumber = dateNumber.toString().substr(0, 19);
  }
  let date = new Date(dateNumber);
  let y: string = String(date.getFullYear());
  let M: string = String(date.getMonth() + 1);
  let d: string = String(date.getDate());
  let h: string = String(date.getHours());
  let m: string = String(date.getMinutes());
  let s: string = String(date.getSeconds());
  format = format.replace('yyyy', y);
  format = format.replace('MM', coverData(M));
  format = format.replace('M', M);
  format = format.replace('dd', coverData(d));
  format = format.replace('d', d);
  format = format.replace('HH', coverData(h));
  format = format.replace('H', h);
  format = format.replace('mm', coverData(m));
  format = format.replace('m', m);
  format = format.replace('ss', coverData(s));
  format = format.replace('s', s);
  return format;
};

export const convertDateToMMMddyyyy = (dateString: String) => {
  // Split the input string by hyphens
  const [day, month, year] = dateString.split('-');

  // Array of abbreviated month names (index 0 is January, 11 is December)
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  // Convert the month number to an abbreviated month name
  const monthName = monthNames[parseInt(month) - 1];

  // Combine the parts in the desired format
  return `${monthName}-${day}-${year}`;
};

export const formatDate = (timestamp: number) => {
  if (!timestamp) return timestamp;
  const date = new Date(timestamp);

  const monthAbbreviation = new Intl.DateTimeFormat('en-US', {
    month: 'short'
  }).format(date);

  const day = date.getDate();
  const year = date.getFullYear();

  return `${monthAbbreviation}-${day}-${year}`;
};

export const formatDateTime = (timestamp: number) => {
  if (!timestamp) return timestamp;
  const date = new Date(timestamp);

  const monthAbbreviation = new Intl.DateTimeFormat('en-US', {
    month: 'short'
  }).format(date);
  const dayAbbreviation = new Intl.DateTimeFormat('en-US', {
    day: '2-digit'
  }).format(date);
  const year = date.getFullYear();

  const hoursAbbreviation = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    hour12: false
  }).format(date);
  const minuteAbbreviation = new Intl.DateTimeFormat('en-US', {
    minute: '2-digit'
  }).format(date);
  const secondsAbbreviation = new Intl.DateTimeFormat('en-US', {
    second: '2-digit'
  }).format(date);

  return `${monthAbbreviation}-${dayAbbreviation}-${year} ${coverData(
    hoursAbbreviation
  )}:${coverData(minuteAbbreviation)}:${coverData(secondsAbbreviation)}`;
};

export const coverData = (obj = '', n = 2) => {
  obj = obj.toString();
  if (obj.length >= n) {
    return obj;
  }
  obj = '0000000000' + obj;
  return obj.substr(obj.length - n);
};

export const store = (name: any) => {
  let __store: any = window.localStorage;
  let store = __store.getItem(name);
  try {
    store = store ? Base64.decode(store) : store;
  } catch (err) {
    store = '';
  }

  return {
    set: (data: any) => {
      data = Base64.encodeURI(
        isObject(data) || isArray(data) ? JSON.stringify(data) : data
      );
      __store.setItem(name, data);
    },
    get: () => (isObjectString(store) ? JSON.parse(store) : store),
    remove: () => __store.removeItem(name)
  };
};

const cookieName = 'auth-token';
export const clearCookie = function () {
  cookie(cookieName).remove();
};
export const getCookie = function () {
  return cookie(cookieName).get();
};

const credentialName = 'identity-proof';
export const clearCredential = function () {
  cookie(credentialName).remove();
};
export const getCredential = function () {
  return cookie(credentialName).get();
};

const keyName = 'auth-key';
export const clearKey = function () {
  cookie(keyName).remove();
};
export const getKey = function () {
  return cookie(keyName).get();
};

export const cookie = function (name: any) {
  return {
    get: function () {
      return name ? Icookie.get(name) : Icookie.all();
    },
    set: function (data: any) {
      return Icookie.set(name, data);
    },
    remove: function () {
      return name ? Icookie.remove(name) : Icookie.clear();
    }
  };
};

export const langDb = {
  en: 'en-US',
  cn: 'zh-CN'
};

export const localesLang = () => {
  const localesLang = 'localesLang';
  let lang = langDb.en;
  return {
    change: () => {
      lang === 'zh-CN'
        ? store(localesLang).set(langDb.en)
        : store(localesLang).set(langDb.cn);
    },
    get: () => lang
  };
};

const generateRandomIv = () => {
  const randomBytes = CryptoJS.lib.WordArray.random(32);
  return randomBytes;
};

export const encrypt = (word: any) => {
  let encrypted = '';
  let key = CryptoJS.enc.Utf8.parse(getKey().toString());
  let iv = generateRandomIv();
  if (typeof word == 'string') {
    const srcs = CryptoJS.enc.Utf8.parse(word);

    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  } else if (typeof word == 'object') {
    const data = JSON.stringify(word);
    const srcs = CryptoJS.enc.Utf8.parse(data);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }
  return encrypted;
};

export const decrypt = (word: string) => {
  let key = CryptoJS.enc.Utf8.parse(getKey().toString());
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};
